import { useEffect, useState } from "react";
import { useSettingsController } from "../controller";
import { SettingsCard } from "./SettingsCard";
import { SettingsItem } from "./SettingsItem";

export const QuextIntegration = () => {
  const { currentSettings, updateSettings } = useSettingsController();
  const [editMode, setEditMode] = useState(false);

  const [quextCustomerId, setQuextCustomerId] = useState("");

  const settings = currentSettings.quext;

  useEffect(() => {
    setQuextCustomerId(settings.quextCustomerId || "");
  }, [settings.quextCustomerId]);

  return (
    <SettingsCard
      title="Quext Integration"
      editMode={editMode}
      setEditMode={setEditMode}
      onSave={() => {
        if (settings.quextCustomerId !== quextCustomerId)
          updateSettings({
            quextCustomerId
          });
      }}
    >
      <SettingsItem
        title="Customer ID"
        value={quextCustomerId}
        editMode={editMode}
        onChange={setQuextCustomerId}
      />
    </SettingsCard>
  );
};
